import Application from "./Application";
import PreloaderScene from "./scenes/PreloaderScene";
import common from "./common";
import SoundManager from "./utils/SoundManager";
import BoardGraphicGenerator from "./boardGraphics/BoardGraphicGenerator";
import SubmitButton from "./ui/SubmitButton";
import SaveData from "./utils/SaveData";

export default class Main {

    constructor()
    {
        this.app = null;
        this.preloader = null;
        this.videoPlayer = null;
        this.videoSkipButton = null;
        this.lastTimestamp = null;
    }

    init()
    {
        var urlParams = new URLSearchParams(window.location.search);
        common.country = urlParams.get('language') || 'en';

        common.basicMode = BASIC_MODE;
        console.log('BASIC_MODE', common.basicMode);

        if((!this.hasWebGL() || common.country == 'zh') && !common.basicMode)
        {
            MEDIATOR.redirectToBasicMode();
        }

        common.baseUrl = './';

        common.soundManager = new SoundManager();

        common.div = $('#game');
        console.log(common.div);

        common.rotateScreen = $('#p3-rotateScreen');
        
        var ua = window.navigator.userAgent;
        if(ua.indexOf("Android") > -1)
        {
            common.isAndroid = true;
        }
        if(ua.indexOf("Silk") > -1)
        {
            common.isKindle = true;
        }
        if(ua.indexOf("Mac OS X") > -1)
        {
            common.isMac = true;
        }
        if(/MSIE|Trident/.test(ua))
        {
            common.isIE = true;
        }
        if(/Firefox/.test(ua))
        {
            common.isFirefox = true;
        }
        if(/Edg/.test(ua))
        {
            common.isEdge = true;
        }

        if(!common.basicMode)
        {
            common.boardGraphicGenerator = new BoardGraphicGenerator();
        }

        this.preloader = new PreloaderScene();
        this.preloader.init();
        this.preloader.signalListeners.push(
            this.preloader.signals.next.add(()=>{
                this.preloader.destroy();
                this.start();
            }, this)
        );
        
        window.requestAnimationFrame((timestamp) => {
            this.update(timestamp);
        });

        this.onVideoComplete();
        return;
        if(!common.basicMode)
        {
            var that = this;

            var videoId = '461886752';
            if($(window).height() < $(window).width())
            {
                videoId = '461887121'; 
            }
            var muted = '1';
            if(common.isIE || common.isEdge)
            {
                muted = '0';
            }

            var vimeoDiv = $('<iframe id="p3-vimeo-player" style="position:absolute; width:100%; height:100%;" src="https://player.vimeo.com/video/' + videoId + '?autoplay=1&amp;muted=' + muted + '&amp;loop=0" width="640" height="360" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" webkitallowfullscreen="" mozallowfullscreen="" allowfullscreen="" data-vimeo-muted="' + (muted == '1' ? 'true' : 'false') + '"></iframe>');
            $('#p3-video-holder').append(vimeoDiv);

            var player = new Vimeo.Player(vimeoDiv);

            player.setColor('#f8cd25');

            player.on('play', function() {
                console.log('video playing')
            });

            player.on('ended', (data) => {
                console.log('video ended');
                this.onVideoComplete();
            });

            player.getVideoTitle().then(function(title) {
                console.log('title:', title);
            });

            player.play();
            
            /*
            if($(window).height() < $(window).width())
            {
                player.loadVideo(461887121);
                player.play();
                if(common.isIE || common.isEdge || common.isFirefox)
                {
                    player.setMuted(false);
                }
            }*/

            this.videoPlayer = player;

            /*
            videojs('dhl-video').ready(function()
            {
                that.videoPlayer = this;
                that.videoPlayer.on('ended', that.onVideoComplete.bind(this));
            });*/
        }
    }


    start()
    {
        common.saveData = new SaveData();
        if(common.saveData.muted)
        {
            common.soundManager.mute();
        }

        this.app = new Application();
        this.app.init();
    }

    update(timestamp)
    {
        if(this.lastTimestamp == null)
            this.lastTimestamp = timestamp;

        var dt = timestamp - this.lastTimestamp;
        if(this.app && this.app.currentScene)
        {
            this.app.currentScene.update(dt)
        }
        else if(this.preloader)
        {
            this.preloader.update(dt);
        }

        if($(window).height() > $(window).width())
        {
            MEDIATOR.portrait = true;
        }
        else
        {
            MEDIATOR.portrait = false;
        }

        window.requestAnimationFrame((timestamp) => {
            this.update(timestamp);
        });

        if(!common.basicMode)
        {
            if(MEDIATOR.portrait)
            {
                var button = $('#p3-basic-button-holder').children().first();
                $('#p3-vimeo-player').css('maxHeight', 'calc(100% - ' + button.height() + 'px - ' + $('#p3-basic-button-holder').css('bottom') + ' - ' + button.css('padding-bottom') + ' - ' + button.css('padding-top') + ' - 2vh)');
                $('#p3-basic-button-holder').css({'bottom': '1vh', 'top': 'auto'});
            }
            else
            {
                $('#p3-basic-button-holder').css({'bottom': 'auto', 'top': '1vh'});
            }
            /*
            $('#dhl-video_html5_api').css({
                'height': '100%',
                'width': videoWidth + 'px',
                'left': (($(window).width()/2) - (videoWidth/2)) + 'px'
            });
            $('.vjs-control-bar').css({
                'visibility':'hidden'
            });
            $('.vjs-big-play-button').css({
                'border': 'none',
                'backgroundColor': '#ffcc01',
                'color': '#d40112'
            });
            */

            if(this.videoSkipButton == null && common.config.strings)
            {
                /*var videoWidth = $(window).height() * (16/9);
                if($(window).height() > $(window).width())
                {
                    videoWidth = $(window).height() * (4/5);
                    this.videoPlayer.src(common.baseUrl + 'assets/video/dhl_intro_mobile.mp4');
                }
                else
                {
                    this.videoPlayer.src(common.baseUrl + 'assets/video/dhl_intro.mp4');
                }*/

                var skipHolder = $('<div id="p3-video-skip-holder"></div>');
                $('#p3-video-holder').append(skipHolder);
                this.videoSkipButton = new SubmitButton(common.config.strings.skip[common.country]);
                skipHolder.append(this.videoSkipButton.htmlElement);

                var signal = this.videoSkipButton.signals.up.add(() => {
                    signal.detach();
                    this.videoPlayer.pause();
                    $('#p3-video-holder').hide();
                    common.introVideoFinished = true;
                });

                //this.videoPlayer.play();
            }
            else if(this.videoSkipButton)
            {
                if(MEDIATOR.portrait)
                {
                    $('#p3-video-skip-holder').css('bottom', '1vh');
                }
                else
                {
                    $('#p3-video-skip-holder').css('bottom', '50vh');
                }
            }
        }
    }

    onVideoComplete()
    {
        console.log('video complete');
        common.introVideoFinished = true;
        $('#p3-video-holder').fadeOut(400, () =>{
            $('#p3-video-holder').hide();
        });
    }

    hasWebGL()
    {
        var supported;
    
        try {
            var canvas = document.createElement('canvas');
            supported = !! window.WebGLRenderingContext && (canvas.getContext('webgl') || canvas.getContext('experimental-webgl'));
        } catch(e) { supported = false; }
    
        try {
            eval('let foo = 123;');
        } catch (e) { supported = false; }
    
        if (supported === false) {
            console.log("WebGL is not supported");
        }
    
        canvas = undefined;
    
        return supported;
    }
}


